// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════
   Locked / Coming Soon pages
═══════════════════════════════════════════════════════════ */
.locked__wrap { display: flex; justify-content: center; padding: 1rem 0 2rem; }

.locked__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 3rem 2.5rem;
  max-width: 520px;
  width: 100%;
  gap: 1.25rem;
}

.locked__icon-ring {
  width: 5rem; height: 5rem;
  border-radius: 50%;
  background: linear-gradient(135deg, #1e2a1e 0%, #2d3e2d 100%);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 0 0 8px rgba(30,42,30,0.08);
}
.locked__icon { font-size: 2rem; color: #b85c38; }

.locked__title {
  font-family: var(--portal-serif, Georgia, serif);
  font-size: 1.6rem; font-weight: 700;
  color: #1b1b1b; margin: 0;
}
.locked__sub {
  font-size: 0.92rem; color: var(--portal-muted, #6b6258);
  line-height: 1.7; margin: 0; max-width: 400px;
}

/* Steps (used by ApplyRetreat) */
.locked__steps {
  display: flex; flex-direction: column; gap: 0.75rem;
  width: 100%; text-align: left;
  background: var(--portal-surface, #faf7f2);
  border-radius: 10px; padding: 1.25rem 1.5rem;
}
.locked__step {
  display: flex; align-items: flex-start; gap: 0.85rem;
  font-size: 0.88rem; color: #1b1b1b; line-height: 1.55;
}
.locked__step-num {
  width: 1.6rem; height: 1.6rem; border-radius: 50%;
  background: #1e2a1e; color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-size: 0.72rem; font-weight: 800; flex-shrink: 0;
}

.locked__actions { display: flex; gap: 0.75rem; flex-wrap: wrap; justify-content: center; }

.locked__timeline-note {
  display: flex; align-items: center; gap: 0.5rem;
  font-size: 0.78rem; color: var(--portal-muted, #6b6258);
  background: rgba(184,92,56,0.05);
  border: 1px solid rgba(184,92,56,0.15);
  border-radius: 8px; padding: 0.65rem 1rem;
  width: 100%; text-align: left;
}
.locked__timeline-note svg { flex-shrink: 0; color: #b85c38; }
`, "",{"version":3,"sources":["webpack://./src/portal/locked.css"],"names":[],"mappings":"AAAA;;6DAE6D;AAC7D,gBAAgB,aAAa,EAAE,uBAAuB,EAAE,oBAAoB,EAAE;;AAE9E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,yCAAyC;AAC3C;AACA,gBAAgB,eAAe,EAAE,cAAc,EAAE;;AAEjD;EACE,gDAAgD;EAChD,iBAAiB,EAAE,gBAAgB;EACnC,cAAc,EAAE,SAAS;AAC3B;AACA;EACE,kBAAkB,EAAE,mCAAmC;EACvD,gBAAgB,EAAE,SAAS,EAAE,gBAAgB;AAC/C;;AAEA,iCAAiC;AACjC;EACE,aAAa,EAAE,sBAAsB,EAAE,YAAY;EACnD,WAAW,EAAE,gBAAgB;EAC7B,0CAA0C;EAC1C,mBAAmB,EAAE,uBAAuB;AAC9C;AACA;EACE,aAAa,EAAE,uBAAuB,EAAE,YAAY;EACpD,kBAAkB,EAAE,cAAc,EAAE,iBAAiB;AACvD;AACA;EACE,aAAa,EAAE,cAAc,EAAE,kBAAkB;EACjD,mBAAmB,EAAE,WAAW;EAChC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,kBAAkB,EAAE,gBAAgB,EAAE,cAAc;AACtD;;AAEA,mBAAmB,aAAa,EAAE,YAAY,EAAE,eAAe,EAAE,uBAAuB,EAAE;;AAE1F;EACE,aAAa,EAAE,mBAAmB,EAAE,WAAW;EAC/C,kBAAkB,EAAE,mCAAmC;EACvD,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB,EAAE,qBAAqB;EACzC,WAAW,EAAE,gBAAgB;AAC/B;AACA,6BAA6B,cAAc,EAAE,cAAc,EAAE","sourcesContent":["/* ═══════════════════════════════════════════════════════════\n   Locked / Coming Soon pages\n═══════════════════════════════════════════════════════════ */\n.locked__wrap { display: flex; justify-content: center; padding: 1rem 0 2rem; }\n\n.locked__card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 3rem 2.5rem;\n  max-width: 520px;\n  width: 100%;\n  gap: 1.25rem;\n}\n\n.locked__icon-ring {\n  width: 5rem; height: 5rem;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #1e2a1e 0%, #2d3e2d 100%);\n  display: flex; align-items: center; justify-content: center;\n  box-shadow: 0 0 0 8px rgba(30,42,30,0.08);\n}\n.locked__icon { font-size: 2rem; color: #b85c38; }\n\n.locked__title {\n  font-family: var(--portal-serif, Georgia, serif);\n  font-size: 1.6rem; font-weight: 700;\n  color: #1b1b1b; margin: 0;\n}\n.locked__sub {\n  font-size: 0.92rem; color: var(--portal-muted, #6b6258);\n  line-height: 1.7; margin: 0; max-width: 400px;\n}\n\n/* Steps (used by ApplyRetreat) */\n.locked__steps {\n  display: flex; flex-direction: column; gap: 0.75rem;\n  width: 100%; text-align: left;\n  background: var(--portal-surface, #faf7f2);\n  border-radius: 10px; padding: 1.25rem 1.5rem;\n}\n.locked__step {\n  display: flex; align-items: flex-start; gap: 0.85rem;\n  font-size: 0.88rem; color: #1b1b1b; line-height: 1.55;\n}\n.locked__step-num {\n  width: 1.6rem; height: 1.6rem; border-radius: 50%;\n  background: #1e2a1e; color: #fff;\n  display: flex; align-items: center; justify-content: center;\n  font-size: 0.72rem; font-weight: 800; flex-shrink: 0;\n}\n\n.locked__actions { display: flex; gap: 0.75rem; flex-wrap: wrap; justify-content: center; }\n\n.locked__timeline-note {\n  display: flex; align-items: center; gap: 0.5rem;\n  font-size: 0.78rem; color: var(--portal-muted, #6b6258);\n  background: rgba(184,92,56,0.05);\n  border: 1px solid rgba(184,92,56,0.15);\n  border-radius: 8px; padding: 0.65rem 1rem;\n  width: 100%; text-align: left;\n}\n.locked__timeline-note svg { flex-shrink: 0; color: #b85c38; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
